module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.announce) ? _c('p', {
    staticClass: "announce"
  }, [_vm._v(_vm._s(_vm.announce))]) : _vm._e(), (_vm.description) ? _c('div', {
    staticClass: "description-container",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e(), (_vm.length) ? _c('desc-block', {
    attrs: {
      "icon": "schedule",
      "text": _vm.length,
      "title": "Продолжительность"
    }
  }) : _vm._e(), (_vm.teachers) ? _c('desc-block', {
    attrs: {
      "icon": "teachers",
      "text": _vm.teachers,
      "title": "Преподаватели"
    }
  }) : _vm._e(), (_vm.scheduleDescription) ? _c('desc-block', {
    attrs: {
      "icon": "schedule",
      "text": _vm.scheduleDescription,
      "title": "Расписание"
    }
  }) : _vm._e(), (_vm.educationPlan) ? _c('desc-block', {
    attrs: {
      "icon": "plan",
      "text": _vm.educationPlan,
      "title": "Учебный план"
    }
  }) : _vm._e(), (_vm.programTarget) ? _c('desc-block', {
    attrs: {
      "icon": "target",
      "text": _vm.programTarget,
      "title": "Цели программы"
    }
  }) : _vm._e(), (_vm.expectedResults) ? _c('desc-block', {
    attrs: {
      "icon": "result",
      "text": _vm.expectedResults,
      "title": "Результат программы"
    }
  }) : _vm._e(), (_vm.specialConditions) ? _c('desc-block', {
    attrs: {
      "icon": "conditions",
      "text": _vm.specialConditions,
      "title": "Особые условия проведения"
    }
  }) : _vm._e(), (_vm.materialBase) ? _c('desc-block', {
    attrs: {
      "icon": "base",
      "text": _vm.materialBase,
      "title": "Материально-техническая база"
    }
  }) : _vm._e(), (_vm.priceDescription) ? _c('desc-block', {
    attrs: {
      "icon": "price",
      "text": _vm.priceDescription,
      "title": "Стоимость"
    }
  }) : _vm._e(), (_vm.educationBase) ? _c('desc-block', {
    attrs: {
      "icon": "plan",
      "text": _vm.educationBase,
      "title": "Учебно-методическое обеспечение"
    }
  }) : _vm._e(), (_vm.video.length) ? _c('desc-block', {
    attrs: {
      "video": true,
      "icon": "video",
      "text": _vm.video,
      "title": "Видео"
    }
  }) : _vm._e(), (_vm.seoFooter) ? _c('div', {
    staticClass: "seo-container",
    domProps: {
      "innerHTML": _vm._s(_vm.seoFooter)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b46e998e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/description/Description.vue
// module id = 15870cc6d8ea70d30a7b
// module chunks = 5